import { AuthError, ForbiddenError, HttpError } from "../HttpError";

export const handleFetchError = async (response: Response) => {
  let errorMessage: string;
  try {
    const errorData = await response.json();
    errorMessage = errorData.message || `HTTP error! Status: ${response.status}`;
  } catch {
    errorMessage = `HTTP error! Status: ${response.status}`;
  }

  if (response.status === 401) {
    throw new AuthError(errorMessage);
  }

  if (response.status === 403) {
    throw new ForbiddenError(errorMessage);
  }

  throw new HttpError(errorMessage, response.status);
};
